import PropTypes from 'prop-types';

export const DrugListMap = PropTypes.shape({
  stateCd: PropTypes.string,
  countryCd: PropTypes.string,
  drugList: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string
  })
});
